// Translations for /community/top-sharers leaderboard page.
// Each lang entry overrides selected strings; missing keys fall back to the
// English defaults inlined in CommunityLeaderboard.jsx via `t.key || "…"`.
//
// This keeps the page reachable in every supported language without forcing
// 26 full translations upfront — marketing copy for Slovak (primary market)
// plus top EU markets is prioritized; we can auto-translate the rest later.

export const communityTranslations = {
  en: {
    comm_back: "← TopRankPulse Studio",
    comm_last30: "Last 30 days",
    comm_title_a: "Top sharers",
    comm_title_b: "earning free credits",
    comm_desc: "Every time someone redeems your personal code, you earn +10 credits. The more you share, the higher you climb.",
    comm_prize_eyebrow: "Monthly prize pool",
    comm_prize_body: "bonus credits for the top 3 every 1st of the month.",
    comm_stat_credits: "Credits earned together",
    comm_stat_referrals: "Successful referrals",
    comm_loading: "Loading leaderboard…",
    comm_empty_title: "Be the first on the leaderboard",
    comm_empty_sub: "Share your personal code below — every redeem earns you +10 credits.",
    comm_hof_title: "Hall of Fame",
    comm_hof_sub: "Past champions",
    comm_hof_prize: "prize",
    comm_hof_refs: "referrals",
    comm_your_code: "Your code",
    comm_join_title: "Want in on this?",
    comm_join_sub: "Sign up to get your personal referral code + 3 starter credits.",
    comm_join_cta: "Join and share",
    comm_label_champion: "🏆 Champion",
    comm_label_rising: "🥈 Rising star",
    comm_label_top: "🥉 Top sharer",
    comm_referral_one: "referral",
    comm_referral_many: "referrals",
    // Reel Director bar
    rd_eyebrow: "AI REEL DIRECTOR · NEW",
    rd_headline: "Describe your ad in one sentence. Get a shippable reel.",
    rd_mode_single: "Single scene",
    rd_mode_multi: "Multi-scene story",
    rd_mode_batch: "Batch (5 variants)",
    rd_scenes_label: "Scenes:",
    rd_cta_single: "Generate reel",
    rd_cta_batch: "Generate 5 variants",
    rd_cta_multi: "Generate {n}-scene reel",
    rd_cta_gen_single: "Directing your reel… (~10s)",
    rd_cta_gen_batch: "Generating 5 variants… (~15s)",
    rd_cta_gen_multi: "Directing {n}-scene story… (~{s}s)",
    rd_variants_done: "{n} variants generated. Click one to open in editor — the others are saved in My Ads.",
    rd_ex_yoga: "Yoga studio in Bratislava — first class free",
    rd_ex_mugs: "Flash sale on ceramic mugs, 48 hours only",
    rd_ex_saas: "Black Friday for my SaaS — 50% off annual plans",
    rd_ex_brunch: "Weekend brunch at my restaurant — pancakes & mimosas",
    // Stock photos modal
    stock_title: "Stock photos",
    stock_placeholder: "nature, city, food, abstract…",
    stock_search: "Search",
    stock_no_results: "No results. Try another search term.",
    stock_not_configured: "Stock photos not configured",
    stock_provided_by: "Photos provided by",
    stock_search_failed: "Search failed",
    stock_load_failed: "Failed to load",
    err_login_required: "Login required for this action",
  },
  sk: {
    comm_back: "← TopRankPulse Studio",
    comm_last30: "Posledných 30 dní",
    comm_title_a: "Top odporúčatelia",
    comm_title_b: "získavajú kredity zadarmo",
    comm_desc: "Zakaždým, keď niekto uplatní tvoj osobný kód, dostaneš +10 kreditov. Čím viac zdieľaš, tým vyššie sa dostaneš.",
    comm_prize_eyebrow: "Mesačná odmena",
    comm_prize_body: "bonusových kreditov pre TOP 3 vždy 1. v mesiaci.",
    comm_stat_credits: "Spoločne získané kredity",
    comm_stat_referrals: "Úspešné odporúčania",
    comm_loading: "Načítavam rebríček…",
    comm_empty_title: "Buď prvý na rebríčku",
    comm_empty_sub: "Zdieľaj svoj osobný kód nižšie — za každé uplatnenie získaš +10 kreditov.",
    comm_hof_title: "Sieň slávy",
    comm_hof_sub: "Bývalí šampióni",
    comm_hof_prize: "výhra",
    comm_hof_refs: "odporúčaní",
    comm_your_code: "Tvoj kód",
    comm_join_title: "Chceš sa zapojiť?",
    comm_join_sub: "Zaregistruj sa a získaj svoj osobný odporúčací kód + 3 štartovacie kredity.",
    comm_join_cta: "Pridaj sa a zdieľaj",
    comm_label_champion: "🏆 Šampión",
    comm_label_rising: "🥈 Rastúca hviezda",
    comm_label_top: "🥉 Top odporúčateľ",
    comm_referral_one: "odporúčanie",
    comm_referral_many: "odporúčaní",
    // Photo Start — whole page (fallbacks used inline in PhotoStart.jsx)
    studio_photostart_eyebrow: "Začni z fotky",
    studio_photostart_title: "Nahraj fotku — AI napíše reklamu.",
    studio_photostart_sub: "Nahraj 1 fotku pre jednu reklamu, alebo 2–5 fotiek pre príbehový reel. GPT-4o Vision prečíta predmet, náladu a paletu — potom napíše copy, ktoré sedí.",
    studio_photostart_click_drop: "Klikni alebo presuň fotky sem",
    studio_photostart_add_more: "Pridaj ďalšiu fotku",
    studio_photostart_max_hint: "max. 5 fotiek, 20 MB každá",
    studio_photostart_mode_single: "Jedna reklama · 1080×1080",
    studio_photostart_mode_reel: "Reel · 1080×1920 (jedna scéna)",
    studio_photostart_hint_label: "Jednoveta (voliteľné)",
    studio_photostart_hint_ph: "napr. Letná akcia na ručne vyrábané keramické hrnčeky",
    studio_photostart_btn_single: "Vygeneruj reklamu",
    studio_photostart_btn_reel: "Vygeneruj príbehový reel",
    studio_photostart_generating: "AI píše tvoju reklamu…",
    studio_photostart_cost_single: "1 kredit · otvorí sa v editore",
    studio_photostart_cost_reel: "{n} kreditov · otvorí sa v editore",
    studio_photostart_auto_reel: "Viac fotiek → príbehový reel ({n} scén)",
    studio_photostart_done: "Hotovo — otváram editor",
    studio_photostart_fail: "Generovanie zlyhalo",
    studio_photostart_need_photo: "Pridaj najprv aspoň jednu fotku.",
    studio_photostart_wait_upload: "Počkaj, kým sa dokončí nahrávanie.",
    studio_photostart_upload_fail: "Nahrávanie zlyhalo, skús znova.",
    studio_photostart_max: "Max. 5 fotiek",
    studio_photostart_too_large: "súbor je príliš veľký (max 20 MB)",
    studio_photostart_pack_done: "Vytvorené {n} reklamy — otváram knižnicu",
    // Studio create options (labels on /studio/create/:type)
    studio_create_opt_ai_title: "AI Mágia ✨",
    studio_create_opt_ai_sub: "Popíš, čo chceš — AI vytvorí prvú verziu",
    studio_create_opt_photo_title: "Začni z fotky",
    studio_create_opt_photo_sub: "Nahraj fotku — AI napíše copy, ktoré sedí k obrázku",
    studio_create_opt_template_title: "Vyberte šablónu",
    studio_create_opt_blank_title: "Prázdne plátno",
    // Landing header — Products dropdown + user menu
    nav_products: "Produkty",
    nav_prod_free: "Zadarmo",
    nav_prod_paid: "Platené — mesačne",
    nav_prod_studio: "Studio",
    nav_prod_plugins: "Pluginy & Integrácie",
    // Dashboard welcome
    dash_welcome: "Vitaj, {name}!",
    dash_welcome_sub: "Toto je tvoj domovský panel. Spusti skeny, sleduj viditeľnosť a rozbehni kampane.",
    // Services showcase
    svc_free_badge: "ZADARMO",
    svc_free_title: "Bezplatné nástroje v tvojom účte",
    svc_paid_title: "Prémiové doplnky",
    svc_paid_sub: "Odomkni pokročilé AI sledovanie, monitoring a automatizáciu. Môžeš zrušiť kedykoľvek.",
    svc_upgrade: "Upgraduj pre všetky funkcie",
    svc_scan_label: "Nový SEO Sken",
    svc_scan_desc: "Okamžitý SEO/GEO sken pre ľubovoľnú URL",
    svc_aisim_label: "AI Simulátor",
    svc_aisim_desc: "Pozri ako ChatGPT / Gemini odpovedajú o tebe",
    svc_fix_label: "Fix My SEO",
    svc_fix_desc: "Copy-paste opravy pre tvoj kód",
    svc_plugin_label: "WordPress Plugin",
    svc_plugin_desc: "1-klik inštalácia na tvoj web",
    svc_cookie_label: "Cookie / GDPR Audit",
    svc_cookie_desc: "Kontrola zhody s predpismi",
    svc_local_label: "Local SEO stránky",
    svc_local_desc: "500+ lokálnych landing stránok",
    svc_ads_desc: "AI reel režisér, Foto → Reklama, multi-scéna video editor",
    svc_brand_desc: "Sleduj ako ChatGPT, Gemini & Perplexity ťa spomínajú",
    svc_cs_desc: "Denné upozornenia keď konkurenti rankujú nové kľúčové slová",
    svc_attr_desc: "Zisti ktorá AI engine priniesla každý predaj",
    svc_auto_desc: "Auto-detekcia a auto-opravy SEO problémov 24/7",
    svc_blog_desc: "AI-písané SEO blog články, jednorazový balíček",
    svc_open: "Otvoriť",
    svc_unlock: "Odomknúť",
    nav_p_scan: "AI SEO Sken",
    nav_p_scan_sub: "Okamžitý sken viditeľnosti",
    nav_p_sim: "AI Simulátor",
    nav_p_sim_sub: "Pozri, ako ChatGPT odpovedá o tebe",
    nav_p_ca: "Cookie / GDPR Audit",
    nav_p_ca_sub: "Kontrola zhody s predpismi",
    nav_p_bm_sub: "Sleduj značku cez AI engines",
    nav_p_cs_sub: "Sleduj, na čo sa rankuje konkurencia",
    nav_p_at_sub: "Vedz, ktorá AI ti vracia predaje",
    nav_p_ap_sub: "Automatické opravy SEO 24/7",
    nav_p_ads_sub: "Reklamy, Reels, Fotka → AI",
    nav_p_ba_sub: "Blogovací autopilot",
    nav_p_fx_sub: "Jednorazový pro audit + opravy",
    // User dropdown
    nav_user_plan_suffix: "plán",
    nav_user_upgrade_title: "Odomkni Pro funkcie",
    nav_user_upgrade_sub: "AI Monitor, Competitor Spy, Autopilot + ďalšie. Od €19/mes.",
    nav_user_dashboard: "Dashboard",
    nav_user_my_ads: "Moje reklamy (PulseStudio)",
    nav_user_scan: "Nový SEO Sken",
    nav_user_sim: "AI Simulátor",
    nav_user_referral: "Zarob kredity zdarma",
    nav_user_billing: "Fakturácia & Add-ons",
    nav_user_logout: "Odhlásiť sa",
    nav_mobile_title: "Menu",
    // Photo Start — Epic scenes
    studio_photostart_mode_epic: "Epické scény · AI ťa umiestni do Times Square, štadiónu, kina",
    studio_photostart_btn_epic: "Vygeneruj epické scény",
    studio_photostart_generating_epic: "AI ťa umiestňuje do epických scén… (~40s)",
    studio_photostart_cost_epic: "3 kredity · Times Square + štadión + cover magazínu",
    studio_photostart_cost_epic_dyn: "{n} kreditov · AI ťa umiestni do {n} epických scén",
    studio_photostart_epic_done: "Epické scény hotové — otváram editor",
    studio_photostart_epic_pick_title: "Vyber si až 4 scény",
    studio_photostart_epic_pick_hint: "1 kredit za scénu",
    studio_photostart_epic_need_scene: "Vyber aspoň jednu scénu.",
    // Reel Director bar
    rd_eyebrow: "AI REEL REŽISÉR · NOVÉ",
    rd_headline: "Opíš svoju reklamu jednou vetou. Dostaneš hotový reel.",
    rd_mode_single: "Jedna scéna",
    rd_mode_multi: "Príbeh (viac scén)",
    rd_mode_batch: "Balík (5 variantov)",
    rd_scenes_label: "Scény:",
    rd_cta_single: "Vygeneruj reel",
    rd_cta_batch: "Vygeneruj 5 variantov",
    rd_cta_multi: "Vygeneruj reel z {n} scén",
    rd_cta_gen_single: "Režírujem tvoj reel… (~10s)",
    rd_cta_gen_batch: "Generujem 5 variantov… (~15s)",
    rd_cta_gen_multi: "Režírujem {n}-scénový príbeh… (~{s}s)",
    rd_variants_done: "{n} variantov vygenerovaných. Klikni na jeden a otvor ho v editore — ostatné sú uložené v Moje reklamy.",
    rd_ex_yoga: "Joga štúdio v Bratislave — prvá hodina zadarmo",
    rd_ex_mugs: "Bleskový výpredaj keramických hrnčekov, len 48 hodín",
    rd_ex_saas: "Black Friday pre môj SaaS — 50 % zľava na ročné plány",
    rd_ex_brunch: "Víkendový brunch v mojej reštaurácii — palacinky a mimosy",
    // Stock photos modal
    stock_title: "Stock fotky",
    stock_placeholder: "príroda, mesto, jedlo, abstrakt…",
    stock_search: "Hľadať",
    stock_no_results: "Žiadne výsledky. Skús iný výraz.",
    stock_not_configured: "Stock fotky nie sú nakonfigurované",
    stock_provided_by: "Fotky poskytuje",
    stock_search_failed: "Vyhľadávanie zlyhalo",
    stock_load_failed: "Načítanie zlyhalo",
    err_login_required: "Na túto akciu sa musíš prihlásiť",
  },
  cs: {
    comm_last30: "Posledních 30 dnů",
    comm_title_a: "Top sdílející",
    comm_title_b: "získávají kredity zdarma",
    comm_desc: "Kdykoli někdo uplatní tvůj osobní kód, získáš +10 kreditů. Čím víc sdílíš, tím výš se dostaneš.",
    comm_prize_eyebrow: "Měsíční odměna",
    comm_prize_body: "bonusových kreditů pro TOP 3 každý 1. v měsíci.",
    comm_stat_credits: "Společně získané kredity",
    comm_stat_referrals: "Úspěšná doporučení",
    comm_loading: "Načítám žebříček…",
    comm_empty_title: "Buď první v žebříčku",
    comm_empty_sub: "Sdílej svůj kód níže — každé uplatnění = +10 kreditů.",
    comm_hof_title: "Síň slávy",
    comm_hof_sub: "Bývalí šampioni",
    comm_hof_prize: "odměna",
    comm_hof_refs: "doporučení",
    comm_your_code: "Tvůj kód",
    comm_join_title: "Chceš se zapojit?",
    comm_join_sub: "Zaregistruj se a získej osobní referral kód + 3 startovací kredity.",
    comm_join_cta: "Připoj se a sdílej",
    comm_label_champion: "🏆 Šampion",
    comm_label_rising: "🥈 Vycházející hvězda",
    comm_label_top: "🥉 Top sdílející",
    comm_referral_one: "doporučení",
    comm_referral_many: "doporučení",
    rd_eyebrow: "AI REEL REŽISÉR · NOVÉ",
    rd_headline: "Popiš svou reklamu jednou větou. Dostaneš hotový reel.",
    rd_mode_single: "Jedna scéna",
    rd_mode_multi: "Příběh (více scén)",
    rd_mode_batch: "Balík (5 variant)",
    rd_scenes_label: "Scény:",
    rd_cta_single: "Vygeneruj reel",
    rd_cta_batch: "Vygeneruj 5 variant",
    rd_cta_multi: "Vygeneruj reel z {n} scén",
    rd_cta_gen_single: "Režíruji tvůj reel… (~10s)",
    rd_cta_gen_batch: "Generuji 5 variant… (~15s)",
    rd_cta_gen_multi: "Režíruji {n}-scénový příběh… (~{s}s)",
    rd_variants_done: "{n} variant vygenerováno. Klikni na jednu, ostatní jsou v Moje reklamy.",
    rd_ex_yoga: "Jóga studio v Praze — první lekce zdarma",
    rd_ex_mugs: "Bleskový výprodej keramických hrnků, jen 48 hodin",
    rd_ex_saas: "Black Friday pro můj SaaS — 50 % sleva na roční plány",
    rd_ex_brunch: "Víkendový brunch v mé restauraci — palačinky a mimosy",
    stock_title: "Stock fotky",
    stock_placeholder: "příroda, město, jídlo, abstrakt…",
    stock_search: "Hledat",
    stock_no_results: "Žádné výsledky. Zkus jiný výraz.",
    stock_not_configured: "Stock fotky nejsou nakonfigurovány",
    stock_provided_by: "Fotky poskytuje",
    stock_search_failed: "Hledání selhalo",
    stock_load_failed: "Načítání selhalo",
    err_login_required: "Pro tuto akci je nutné se přihlásit",
  },
  de: {
    comm_last30: "Letzte 30 Tage",
    comm_title_a: "Top-Teiler",
    comm_title_b: "verdienen Gratis-Credits",
    comm_desc: "Jedes Mal, wenn jemand deinen persönlichen Code einlöst, bekommst du +10 Credits. Je mehr du teilst, desto weiter kommst du nach oben.",
    comm_prize_eyebrow: "Monatlicher Preispool",
    comm_prize_body: "Bonus-Credits für die Top 3 am 1. jeden Monats.",
    comm_stat_credits: "Gemeinsam verdiente Credits",
    comm_stat_referrals: "Erfolgreiche Empfehlungen",
    comm_loading: "Rangliste wird geladen…",
    comm_empty_title: "Sei der Erste auf der Rangliste",
    comm_empty_sub: "Teile deinen persönlichen Code — jede Einlösung = +10 Credits.",
    comm_hof_title: "Hall of Fame",
    comm_hof_sub: "Ehemalige Champions",
    comm_hof_prize: "Gewinn",
    comm_hof_refs: "Empfehlungen",
    comm_your_code: "Dein Code",
    comm_join_title: "Du willst dabei sein?",
    comm_join_sub: "Registriere dich für deinen persönlichen Referral-Code + 3 Start-Credits.",
    comm_join_cta: "Mitmachen und teilen",
    comm_label_champion: "🏆 Champion",
    comm_label_rising: "🥈 Aufsteiger",
    comm_label_top: "🥉 Top-Teiler",
    comm_referral_one: "Empfehlung",
    comm_referral_many: "Empfehlungen",
    rd_eyebrow: "AI REEL DIRECTOR · NEU",
    rd_headline: "Beschreibe deine Anzeige in einem Satz. Erhalte einen fertigen Reel.",
    rd_mode_single: "Einzelne Szene",
    rd_mode_multi: "Story (mehrere Szenen)",
    rd_mode_batch: "Paket (5 Varianten)",
    rd_scenes_label: "Szenen:",
    rd_cta_single: "Reel erstellen",
    rd_cta_batch: "5 Varianten erstellen",
    rd_cta_multi: "{n}-Szenen-Reel erstellen",
    rd_cta_gen_single: "Erstelle deinen Reel… (~10s)",
    rd_cta_gen_batch: "Generiere 5 Varianten… (~15s)",
    rd_cta_gen_multi: "Erstelle {n}-Szenen-Story… (~{s}s)",
    rd_variants_done: "{n} Varianten erstellt. Klicke eine an — die anderen sind in Meine Anzeigen.",
    rd_ex_yoga: "Yoga-Studio in Berlin — erste Stunde kostenlos",
    rd_ex_mugs: "Blitzverkauf von Keramiktassen, nur 48 Stunden",
    rd_ex_saas: "Black Friday für mein SaaS — 50 % Rabatt auf Jahrespläne",
    rd_ex_brunch: "Wochenend-Brunch — Pancakes & Mimosas",
    stock_title: "Stock-Fotos",
    stock_placeholder: "Natur, Stadt, Essen, abstrakt…",
    stock_search: "Suchen",
    stock_no_results: "Keine Ergebnisse. Versuche einen anderen Begriff.",
    stock_not_configured: "Stock-Fotos nicht konfiguriert",
    stock_provided_by: "Fotos bereitgestellt von",
    stock_search_failed: "Suche fehlgeschlagen",
    stock_load_failed: "Laden fehlgeschlagen",
    err_login_required: "Für diese Aktion ist eine Anmeldung erforderlich",
  },
  pl: {
    comm_last30: "Ostatnie 30 dni",
    comm_title_a: "Top udostępniający",
    comm_title_b: "zdobywają darmowe kredyty",
    comm_desc: "Za każdym razem, gdy ktoś wykorzysta twój osobisty kod, dostajesz +10 kredytów.",
    comm_prize_eyebrow: "Miesięczna pula nagród",
    comm_prize_body: "bonusowych kredytów dla TOP 3 każdego 1. dnia miesiąca.",
    comm_stat_credits: "Wspólnie zdobyte kredyty",
    comm_stat_referrals: "Udane polecenia",
    comm_loading: "Ładowanie rankingu…",
    comm_empty_title: "Bądź pierwszy w rankingu",
    comm_empty_sub: "Udostępnij swój kod — każde wykorzystanie = +10 kredytów.",
    comm_hof_title: "Galeria sław",
    comm_hof_sub: "Poprzedni mistrzowie",
    comm_hof_prize: "nagroda",
    comm_hof_refs: "poleceń",
    comm_your_code: "Twój kod",
    comm_join_title: "Chcesz dołączyć?",
    comm_join_sub: "Zarejestruj się i zdobądź osobisty kod + 3 startowe kredyty.",
    comm_join_cta: "Dołącz i udostępnij",
    comm_label_champion: "🏆 Mistrz",
    comm_label_rising: "🥈 Wschodząca gwiazda",
    comm_label_top: "🥉 Top udostępniający",
    comm_referral_one: "polecenie",
    comm_referral_many: "poleceń",
    rd_eyebrow: "AI REEL REŻYSER · NOWE",
    rd_headline: "Opisz swoją reklamę jednym zdaniem. Dostaniesz gotowy reel.",
    rd_mode_single: "Jedna scena",
    rd_mode_multi: "Historia (wiele scen)",
    rd_mode_batch: "Pakiet (5 wariantów)",
    rd_scenes_label: "Sceny:",
    rd_cta_single: "Generuj reel",
    rd_cta_batch: "Generuj 5 wariantów",
    rd_cta_multi: "Generuj reel z {n} scen",
    rd_cta_gen_single: "Reżyseruję twój reel… (~10s)",
    rd_cta_gen_batch: "Generuję 5 wariantów… (~15s)",
    rd_cta_gen_multi: "Reżyseruję {n}-scenową historię… (~{s}s)",
    rd_variants_done: "{n} wariantów wygenerowanych. Kliknij jeden — pozostałe są w Moje reklamy.",
    rd_ex_yoga: "Studio jogi w Warszawie — pierwsza lekcja za darmo",
    rd_ex_mugs: "Błyskawiczna wyprzedaż kubków ceramicznych, tylko 48 godzin",
    rd_ex_saas: "Black Friday dla mojego SaaS — 50% na roczne plany",
    rd_ex_brunch: "Weekendowy brunch — naleśniki i mimozy",
    stock_title: "Zdjęcia stockowe",
    stock_placeholder: "natura, miasto, jedzenie, abstrakt…",
    stock_search: "Szukaj",
    stock_no_results: "Brak wyników. Spróbuj innego hasła.",
    stock_not_configured: "Zdjęcia stockowe nie są skonfigurowane",
    stock_provided_by: "Zdjęcia dostarcza",
    stock_search_failed: "Wyszukiwanie nie powiodło się",
    stock_load_failed: "Ładowanie nie powiodło się",
    err_login_required: "Do tej akcji wymagane jest zalogowanie",
  },
  hu: {
    comm_last30: "Utolsó 30 nap",
    comm_title_a: "Top megosztók",
    comm_title_b: "ingyen krediteket keresnek",
    comm_desc: "Minden alkalommal, amikor valaki beváltja a személyes kódodat, +10 kreditet kapsz.",
    comm_prize_eyebrow: "Havi jutalom",
    comm_prize_body: "bónusz kredit a TOP 3-nak minden hó 1-jén.",
    comm_stat_credits: "Közösen szerzett kreditek",
    comm_stat_referrals: "Sikeres ajánlások",
    comm_loading: "Ranglista betöltése…",
    comm_empty_title: "Légy te az első a ranglistán",
    comm_empty_sub: "Oszd meg a kódodat — minden beváltás = +10 kredit.",
    comm_hof_title: "Hírességek Csarnoka",
    comm_hof_sub: "Korábbi bajnokok",
    comm_hof_prize: "jutalom",
    comm_hof_refs: "ajánlás",
    comm_your_code: "A te kódod",
    comm_join_title: "Csatlakoznál?",
    comm_join_sub: "Regisztrálj a személyes ajánlókódodért + 3 induló kreditért.",
    comm_join_cta: "Csatlakozz és ossz meg",
    comm_label_champion: "🏆 Bajnok",
    comm_label_rising: "🥈 Feltörekvő csillag",
    comm_label_top: "🥉 Top megosztó",
    comm_referral_one: "ajánlás",
    comm_referral_many: "ajánlás",
    rd_eyebrow: "AI REEL RENDEZŐ · ÚJ",
    rd_headline: "Írd le a hirdetésed egy mondatban. Kész reelt kapsz.",
    rd_mode_single: "Egy jelenet",
    rd_mode_multi: "Történet (több jelenet)",
    rd_mode_batch: "Csomag (5 változat)",
    rd_scenes_label: "Jelenetek:",
    rd_cta_single: "Reel készítése",
    rd_cta_batch: "5 változat készítése",
    rd_cta_multi: "{n}-jelenetes reel készítése",
    rd_cta_gen_single: "Reel rendezése… (~10s)",
    rd_cta_gen_batch: "5 változat generálása… (~15s)",
    rd_cta_gen_multi: "{n}-jelenetes történet rendezése… (~{s}s)",
    rd_variants_done: "{n} változat generálva. Kattints egyre — a többi a Reklámjaim alatt van.",
    rd_ex_yoga: "Jóga stúdió Budapesten — első óra ingyen",
    rd_ex_mugs: "Villámakció kerámia bögrékre, csak 48 óra",
    rd_ex_saas: "Black Friday a SaaS-omra — 50% kedvezmény éves csomagokra",
    rd_ex_brunch: "Hétvégi brunch — palacsinta és mimosa",
    stock_title: "Stock fotók",
    stock_placeholder: "természet, város, étel, absztrakt…",
    stock_search: "Keresés",
    stock_no_results: "Nincs találat. Próbálj más kifejezést.",
    stock_not_configured: "A stock fotók nincsenek konfigurálva",
    stock_provided_by: "Fotókat biztosítja:",
    stock_search_failed: "A keresés sikertelen",
    stock_load_failed: "Betöltés sikertelen",
    err_login_required: "Ehhez a művelethez bejelentkezés szükséges",
  },
  fr: {
    comm_last30: "30 derniers jours",
    comm_title_a: "Meilleurs partageurs",
    comm_title_b: "gagnent des crédits gratuits",
    comm_desc: "Chaque fois que quelqu'un utilise ton code personnel, tu gagnes +10 crédits.",
    comm_prize_eyebrow: "Cagnotte mensuelle",
    comm_prize_body: "crédits bonus pour le TOP 3 chaque 1er du mois.",
    comm_stat_credits: "Crédits gagnés ensemble",
    comm_stat_referrals: "Parrainages réussis",
    comm_loading: "Chargement du classement…",
    comm_empty_title: "Sois le premier du classement",
    comm_empty_sub: "Partage ton code — chaque utilisation = +10 crédits.",
    comm_hof_title: "Hall of Fame",
    comm_hof_sub: "Anciens champions",
    comm_hof_prize: "prix",
    comm_hof_refs: "parrainages",
    comm_your_code: "Ton code",
    comm_join_title: "Tu veux participer ?",
    comm_join_sub: "Inscris-toi pour obtenir ton code de parrainage + 3 crédits de départ.",
    comm_join_cta: "Rejoindre et partager",
    comm_label_champion: "🏆 Champion",
    comm_label_rising: "🥈 Étoile montante",
    comm_label_top: "🥉 Top partageur",
    comm_referral_one: "parrainage",
    comm_referral_many: "parrainages",
    rd_eyebrow: "AI REEL DIRECTOR · NOUVEAU",
    rd_headline: "Décris ton annonce en une phrase. Obtiens un reel prêt.",
    rd_mode_single: "Scène unique",
    rd_mode_multi: "Histoire (multi-scènes)",
    rd_mode_batch: "Lot (5 variantes)",
    rd_scenes_label: "Scènes :",
    rd_cta_single: "Générer le reel",
    rd_cta_batch: "Générer 5 variantes",
    rd_cta_multi: "Générer reel de {n} scènes",
    rd_cta_gen_single: "Je réalise ton reel… (~10s)",
    rd_cta_gen_batch: "Génération de 5 variantes… (~15s)",
    rd_cta_gen_multi: "Je réalise l'histoire en {n} scènes… (~{s}s)",
    rd_variants_done: "{n} variantes générées. Clique sur une — les autres sont dans Mes annonces.",
    rd_ex_yoga: "Studio de yoga à Paris — premier cours offert",
    rd_ex_mugs: "Vente flash de mugs en céramique, 48h seulement",
    rd_ex_saas: "Black Friday pour mon SaaS — 50 % sur les plans annuels",
    rd_ex_brunch: "Brunch du week-end — pancakes et mimosas",
    stock_title: "Photos stock",
    stock_placeholder: "nature, ville, nourriture, abstrait…",
    stock_search: "Rechercher",
    stock_no_results: "Aucun résultat. Essaie un autre terme.",
    stock_not_configured: "Photos stock non configurées",
    stock_provided_by: "Photos fournies par",
    stock_search_failed: "La recherche a échoué",
    stock_load_failed: "Échec du chargement",
    err_login_required: "Connexion requise pour cette action",
  },
  es: {
    comm_last30: "Últimos 30 días",
    comm_title_a: "Top compartidores",
    comm_title_b: "ganan créditos gratis",
    comm_desc: "Cada vez que alguien canjea tu código personal, ganas +10 créditos.",
    comm_prize_eyebrow: "Bote mensual",
    comm_prize_body: "créditos bonus para el TOP 3 cada 1º de mes.",
    comm_stat_credits: "Créditos ganados juntos",
    comm_stat_referrals: "Referencias exitosas",
    comm_loading: "Cargando clasificación…",
    comm_empty_title: "Sé el primero en la clasificación",
    comm_empty_sub: "Comparte tu código — cada canje = +10 créditos.",
    comm_hof_title: "Salón de la Fama",
    comm_hof_sub: "Campeones anteriores",
    comm_hof_prize: "premio",
    comm_hof_refs: "referencias",
    comm_your_code: "Tu código",
    comm_join_title: "¿Quieres participar?",
    comm_join_sub: "Regístrate y consigue tu código + 3 créditos iniciales.",
    comm_join_cta: "Únete y comparte",
    comm_label_champion: "🏆 Campeón",
    comm_label_rising: "🥈 Estrella emergente",
    comm_label_top: "🥉 Top compartidor",
    comm_referral_one: "referencia",
    comm_referral_many: "referencias",
    rd_eyebrow: "AI REEL DIRECTOR · NUEVO",
    rd_headline: "Describe tu anuncio en una frase. Obtén un reel listo.",
    rd_mode_single: "Una escena",
    rd_mode_multi: "Historia (multi-escena)",
    rd_mode_batch: "Lote (5 variantes)",
    rd_scenes_label: "Escenas:",
    rd_cta_single: "Generar reel",
    rd_cta_batch: "Generar 5 variantes",
    rd_cta_multi: "Generar reel de {n} escenas",
    rd_cta_gen_single: "Dirigiendo tu reel… (~10s)",
    rd_cta_gen_batch: "Generando 5 variantes… (~15s)",
    rd_cta_gen_multi: "Dirigiendo historia de {n} escenas… (~{s}s)",
    rd_variants_done: "{n} variantes generadas. Haz clic en una — las demás están en Mis anuncios.",
    rd_ex_yoga: "Estudio de yoga en Madrid — primera clase gratis",
    rd_ex_mugs: "Oferta flash en tazas de cerámica, solo 48 horas",
    rd_ex_saas: "Black Friday para mi SaaS — 50% en planes anuales",
    rd_ex_brunch: "Brunch de fin de semana — tortitas y mimosas",
    stock_title: "Fotos stock",
    stock_placeholder: "naturaleza, ciudad, comida, abstracto…",
    stock_search: "Buscar",
    stock_no_results: "Sin resultados. Prueba otro término.",
    stock_not_configured: "Fotos stock no configuradas",
    stock_provided_by: "Fotos proporcionadas por",
    stock_search_failed: "Búsqueda fallida",
    stock_load_failed: "Error al cargar",
    err_login_required: "Se requiere iniciar sesión para esta acción",
  },
};
